import React from 'react'

const Review = () => {
  return (
    <div>
        <div class="review" id="Review">
    <h2 class="review-heading">Customer Reviews</h2>

    <div class="review_box">
      <div class="review_card">

        <div class="review_profile">
          </div>

        <div class="review_text">
          <h2 class="name">Aarav</h2>

          <div class="review_icon">
            <i class="fa-solid fa-star"></i>
            <i class="fa-solid fa-star"></i>
            <i class="fa-solid fa-star"></i>
            <i class="fa-solid fa-star"></i>
            <i class="fa-solid fa-star-half-stroke"></i>
          </div>

          <div class="review_social">
            <i class="fa-brands fa-facebook-f"></i>
            <i class="fa-brands fa-instagram"></i>
            <i class="fa-brands fa-twitter"></i>
            <i class="fa-brands fa-linkedin-in"></i>
          </div>

          <p>
            This platform has revolutionized the way we manage payroll and compliance. It's user-friendly and incredibly efficient!
          </p>

        </div>

      </div>

      <div class="review_card">

        <div class="review_profile">
          {/* <!-- <img src="logo comply.png"> --> */}
        </div>

        <div class="review_text">
          <h2 class="name">Anish Kumar</h2>

          <div class="review_icon">
            <i class="fa-solid fa-star"></i>
            <i class="fa-solid fa-star"></i>
            <i class="fa-solid fa-star"></i>
            <i class="fa-solid fa-star"></i>
            <i class="fa-solid fa-star-half-stroke"></i>
          </div>

          <div class="review_social">
            <i class="fa-brands fa-facebook-f"></i>
            <i class="fa-brands fa-instagram"></i>
            <i class="fa-brands fa-twitter"></i>
            <i class="fa-brands fa-linkedin-in"></i>
          </div>

          <p>
            Outstanding service and support! The tools provided have made our compliance and payroll processes seamless and hassle-free.
          </p>

        </div>

      </div>

      <div class="review_card">

        <div class="review_profile">
          {/* <!-- <img src="logo comply.png"> --> */}
        </div>

        <div class="review_text">
          <h2 class="name">Rajeev Kumar</h2>

          <div class="review_icon">
            <i class="fa-solid fa-star"></i>
            <i class="fa-solid fa-star"></i>
            <i class="fa-solid fa-star"></i>
            <i class="fa-solid fa-star"></i>
            <i class="fa-solid fa-star-half-stroke"></i>
          </div>

          <div class="review_social">
            <i class="fa-brands fa-facebook-f"></i>
            <i class="fa-brands fa-instagram"></i>
            <i class="fa-brands fa-twitter"></i>
            <i class="fa-brands fa-linkedin-in"></i>
          </div>

          <p>
            This service has saved us countless hours on payroll and compliance. It's reliable, accurate, and very user-friendly.
          </p>

        </div>

      </div>

    </div>

</div>
    </div>
  )
}

export default Review